export var generateRandomInteger = function (ceil) {
    return Math.floor(Math.random() * Math.floor(ceil));
};
